import type { NotificationType } from '@giftgroup/shared';

/** The inbox, the settings grid, and the push prompt (doc 11 › UX). */
export const notificationsCopy = {
  title: 'Notifications',
  markAllRead: 'Mark all read',
  groups: {
    today: 'Today',
    week: 'This week',
    earlier: 'Earlier',
  },
  empty: {
    title: '🔔 All quiet!',
    body: 'We’ll ping you when there’s gifting news.',
  },
  unread: 'Unread',

  settings: {
    title: 'Notifications',
    intro: 'In-app notifications are always on. Choose how else you’d like to hear.',
    email: 'Email',
    push: 'Push',
    pauseAll: 'Pause all emails',
    pauseAllHint:
      'Nothing by email until you switch this back off. The app still shows everything.',
    saved: 'Saved.',
    pushOff: 'Push isn’t turned on for this device yet.',
    turnOnPush: 'Turn on push',
    pushUnsupported: 'This browser can’t do push notifications.',
    pushBlocked: 'Notifications are blocked in your browser settings for this site.',
    pushOn: 'Push is on for this device.',
    turnOffPush: 'Turn off on this device',
  },

  /** Plain language, in the same order as doc 11's table. */
  types: {
    claimed_item_changed: 'When something I claimed changes',
    claimed_item_removed: 'When something I claimed is removed',
    date_reminder: 'Birthday and date reminders',
  } satisfies Record<NotificationType, string>,

  prompt: {
    title: '🔔 Want a heads-up when something changes?',
    body: 'We’ll ping you if a gift you claimed changes, and before birthdays.',
    turnOn: 'Turn on',
    notNow: 'Not now',
    iosTitle: 'Add Gift Group to your home screen',
    iosBody:
      'On iPhone, notifications work once the app is on your home screen: tap Share, then “Add to Home Screen”, and open it from there.',
    iosGotIt: 'Got it',
    granted: 'You’re all set — we’ll keep you posted.',
    denied: 'No problem. You can turn these on later in Settings › Notifications.',
  },
} as const;
